export default __webpack_public_path__ + "static/media/background1.2218c91a.jpeg";